import { createSlice } from '@reduxjs/toolkit'
import { getAllWarehouse, createWarehouseItem, updateWarehouseItem, deleteWarehouseItem } from './asyncWarehouse'

const initialState = {
    isLoading: false,
    isError: null,
    data: []
}

export const WAREHOUSE_SLICE = createSlice({
    name: 'warehouse',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllWarehouse.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(getAllWarehouse.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload?.data ?? [];
            })
            .addCase(getAllWarehouse.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true
            })
            .addCase(createWarehouseItem.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(createWarehouseItem.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload?.data) {
                    state.data = [action.payload.data, ...state.data];
                }
            })
            .addCase(createWarehouseItem.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(updateWarehouseItem.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(updateWarehouseItem.fulfilled, (state, action) => {
                state.isLoading = false;
                const updated = action.payload?.data;
                if (updated?.id) {
                    state.data = state.data.map((item) => (item.id === updated.id ? updated : item));
                }
            })
            .addCase(updateWarehouseItem.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(deleteWarehouseItem.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(deleteWarehouseItem.fulfilled, (state, action) => {
                state.isLoading = false;
                const deletedId = action.payload?.id;
                if (deletedId) {
                    state.data = state.data.filter((item) => item.id !== deletedId);
                }
            })
            .addCase(deleteWarehouseItem.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            });
    },
})

// Action creators are generated for each case reducer function
export const { } = WAREHOUSE_SLICE.actions

export default WAREHOUSE_SLICE.reducer